const baseUrl = `${window.location.origin}/api`;
const lang = document.documentElement.getAttribute('lang');
const pageid = document.getElementById("currentpageid").innerHTML;

const api = {
  getProducts: () => {
    const target = `${baseUrl}/products/allproducts/?lang=${lang}&pageid=${pageid}`
    return new Promise((resolve, reject) => {
        fetch(target, { cache: "no-store" })
        .then(res => res.json())
        .then(data => resolve(data.Products))
        .catch(error => reject(error))
    })
  },
  getCategories: () => {
      const target = `${baseUrl}/products/productcategories?rootname=Category&lang=${lang}&pageid=${pageid}`
    return new Promise((resolve, reject) => {
        fetch(target, { cache: "no-store" })
        .then(res => res.json())
        .then(data => resolve(data))    
        .catch(error => reject(error))
    })
  },
  getSpecies: () => {
      const target = `${baseUrl}/products/productcategories?rootname=Spieces&lang=${lang}&pageid=${pageid}`
    return new Promise((resolve, reject) => {
        fetch(target, { cache: "no-store" })
        .then(res => res.json())
        .then(data => resolve(data))
        .catch(error => reject(error))
    })
  },
  getTherapies: () => {
      const target = `${baseUrl}/products/productcategories?rootname=Therapy%20area&lang=${lang}&pageid=${pageid}`
    return new Promise((resolve, reject) => {
        fetch(target, { cache: "no-store" })
        .then(res => res.json())
        .then(data => resolve(data))
        .catch(error => reject(error))
    })
  },
}

export default api
